import { ChangeEvent, FC, useState } from "react";
import Switch from "../../../../libs/Switch";
import { useDispatch } from "react-redux";

import { IFormSettings } from "../../../../services/forms";
import { IEmailEditorData } from "../../../../store/settings/types";
import { changeNotificationSettings } from "./../../../../store/settings/actionCreators";
import NotificationTextEditor from "./../RespondentNotification/NotificationTextEditor";
import { IconTypes } from "./../../../../libs/Icon";
import Button from "./../../../../libs/Button";

import styles from "./styles.module.scss";
import useShallowSelector from "../../../../hooks/useShalowSelector";

interface IProps {
    notificationSettings: IFormSettings["notification"];
}

const EmailNotificationSection: FC<IProps> = ({ notificationSettings }) => {
    const dispatch = useDispatch();

    const [, setNotificationIsActive] = useState<boolean>(notificationSettings.emailNotification.isActive);
    const [notificationTitle, setNotificationTitle] = useState<string>(notificationSettings.emailNotification.title);
    const [notificationTo, setNotificationTo] = useState<string>(notificationSettings.emailNotification.to);
    const [notificationMessage, setNotificationMessage] = useState<IEmailEditorData>({
        html: notificationSettings.emailNotification.message,
        json: notificationSettings.emailNotification.json,
    });
    const userData = useShallowSelector(state => state.auth.user);

    const handleNotificationTitle = (e: ChangeEvent<HTMLInputElement>) => setNotificationTitle(e.target.value);
    const handleNotificationTo = (e: ChangeEvent<HTMLInputElement>) => setNotificationTo(e.target.value);

    const handleStateUpdate = (element: any) => {
        dispatch(
            changeNotificationSettings({
                prevState: notificationSettings,
                currentState: element.notification,
            }),
        );
    };

    return (
        <div className={styles.section}>
            <label className={styles.switchContainer}>
                <Switch
                    checked={notificationSettings.emailNotification.isActive}
                    onChange={() => {
                        setNotificationIsActive(state => !state);
                        handleStateUpdate({
                            notification: {
                                ...notificationSettings,
                                emailNotification: {
                                    ...notificationSettings.emailNotification,
                                    isActive: !notificationSettings.emailNotification.isActive,
                                },
                            },
                        });
                    }}
                />

                <p className={styles.subTitle}>Email Notification</p>
            </label>

            {notificationSettings.emailNotification?.isActive && (
                <>
                    <span className={styles.label}>Receive an email, when someone fills your form.</span>

                    <p className={styles.subTitle}>
                        Subject
                        <Button icon={IconTypes.SINGLE_LINE} iconSize={18} />
                    </p>

                    <input
                        type="text"
                        value={notificationTitle}
                        onChange={e => handleNotificationTitle(e)}
                        className={styles.customInput}
                        onBlur={() =>
                            handleStateUpdate({
                                notification: {
                                    ...notificationSettings,
                                    emailNotification: {
                                        ...notificationSettings.emailNotification,
                                        title: notificationTitle,
                                    },
                                },
                            })
                        }
                    />

                    <p className={styles.subTitle}>To</p>
                    <input
                        type="text"
                        value={notificationTo === null ? userData?.email : notificationTo}
                        onChange={e => handleNotificationTo(e)}
                        className={styles.customInput}
                        onBlur={() =>
                            handleStateUpdate({
                                notification: {
                                    ...notificationSettings,
                                    emailNotification: {
                                        ...notificationSettings.emailNotification,
                                        to: notificationTo,
                                    },
                                },
                            })
                        }
                    />

                    <p className={styles.subTitle}>Message</p>

                    <NotificationTextEditor
                        handleChange={e => {
                            setNotificationMessage(e);
                            handleStateUpdate({
                                notification: {
                                    ...notificationSettings,
                                    emailNotification: {
                                        ...notificationSettings.emailNotification,
                                        message: e.html,
                                        json: e.json,
                                    },
                                },
                            });
                        }}
                        invoiceInitial={notificationMessage}
                    />
                </>
            )}
        </div>
    );
};

export default EmailNotificationSection;
